<template>
  <div>
    <div ref="wrap" class="context-menu" :style="styles" v-show="value">
      <div class="context-menu-content">
        <slot></slot>
      </div>
      <div class="context-menu-footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <div @click="close" class="context-menu-backdrop" v-if="value"></div>
  </div>
</template>

<script>
import "./context-menu.css";

export default {
  name: "context-menu",
  props: {
    value: {
      type: Boolean,
    },
    position: {
      type: Object,
    },
  },
  data() {
    return {
      wrapSize: {
        width: 0,
        height: 0,
      },
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("closed");
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.$nextTick(() => {
          const { clientHeight: height, clientWidth: width } = this.$refs.wrap;
          this.wrapSize = { height, width };
        });
      }
    },
  },
  computed: {
    styles() {
      let { top, left } = this.position;
      let offset = 20;
      const { width, height } = this.wrapSize;
      const { innerHeight: windowHeight, innerWidth: windowWidth } = window;
      if (top + height > windowHeight) {
        top = windowHeight - height - offset;
      }

      if (left + width > windowWidth) {
        left = windowWidth - width - offset;
      }
      return {
        top: top + "px",
        left: left + "px",
      };
    },
  },
  mounted() {},
};
</script>
